// Reusable skeleton components for the chat module

// ── Conversation list skeleton (direct messages tab) ─────────────────
export const ConversationSkeleton = ({ count = 6 }) => (
  <div className="conversation-skeleton-list">
    {[...Array(count)].map((_, i) => (
      <div key={i} className="conversation-skeleton">
        <div className="skel skel-avatar" />
        <div className="skel-info">
          <div className="skel skel-name" />
          <div className="skel skel-msg" />
        </div>
        <div className="skel skel-time" />
      </div>
    ))}
  </div>
);

// ── Groups list skeleton ──────────────────────────────────────────────
export const GroupsSkeleton = ({ count = 5 }) => (
  <div className="conversation-skeleton-list">
    {[...Array(count)].map((_, i) => (
      <div key={i} className="conversation-skeleton">
        <div className="skel skel-avatar" />
        <div className="skel-info">
          <div className="skel skel-name" style={{ width: "45%" }} />
          <div className="skel skel-msg" style={{ width: "70%" }} />
          <div className="skel skel-msg" style={{ width: "30%", marginTop: 4 }} />
        </div>
        <div className="skel skel-time" />
      </div>
    ))}
  </div>
);

// ── Users list skeleton ───────────────────────────────────────────────
export const UsersSkeleton = ({ count = 6 }) => (
  <div className="conversation-skeleton-list">
    {[...Array(count)].map((_, i) => (
      <div key={i} className="conversation-skeleton">
        <div className="skel skel-avatar" />
        <div className="skel-info">
          <div className="skel skel-name" style={{ width: "50%" }} />
          <div className="skel skel-msg" style={{ width: "65%" }} />
        </div>
      </div>
    ))}
  </div>
);

// ── Messages skeleton ─────────────────────────────────────────────────
export const MessagesSkeleton = ({ count = 8 }) => (
  <div className="messages-skeleton-list">
    {[...Array(count)].map((_, i) => {
      const isMe = i % 3 === 0;
      return (
        <div key={i} className={`message-skeleton ${isMe ? "sent" : "received"}`}>
          {!isMe && <div className="skel skel-msg-avatar" />}
          <div className="skel-bubble-wrap">
            <div
              className="skel skel-bubble"
              style={{ width: `${120 + (i * 37) % 100}px` }}
            />
            <div className="skel skel-bubble-time" />
          </div>
        </div>
      );
    })}
  </div>
);
